export default function NavItem({ slug = '#', text= 'Default', color = 'white', onClick = null}) {
    const someProps = {}

    if (onClick == null) {
        someProps.href = slug;
    }

    return (
        <div onClick={onClick} className={`nav-item ${color ? 'nav-item__color-' + color : '' }`}>
            <a { ...someProps }>{ text }</a>
            <div className="item-line__outer">
                <div className="item-line"></div>
                <svg id="ui-arrow-head" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.03 9.03"><polyline id="ui-arrow-head-2" className="cls-1" points=".52 .51 9.52 4.51 .52 8.51"/></svg>
            </div>
        </div>
    )
}
